import { useCallback, useEffect, useRef, useState } from 'react'
import { getFilteredDrivers } from 'service/AdminPanelService'
import { getErpErrorMessage } from 'service/ErpService'

export default function useDriverList() {
  const [drivers, setDrivers] = useState<any[]>([])
  const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })
  const [search, setSearch] = useState('')
  const [query, setQuery] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [transportStatus, setTransportStatus] = useState('')
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const sequence = useRef(0)
  const invalidate = useCallback(() => { ++sequence.current }, [])
  const load = useCallback(async () => {
    const requestId = ++sequence.current
    setLoading(true)
    setError('')
    try {
      const { data } = await getFilteredDrivers({ page, search: query, statusFilter,
        ...(statusFilter === 'invalid_number' && transportStatus ? { transportStatus } : {}) })
      if (requestId !== sequence.current) return
      const items = Array.isArray(data) ? data : data.results || []
      setDrivers(items)
      setPagination({ count: data.count ?? items.length, next: data.next || null, previous: data.previous || null })
    } catch (failure) {
      if (requestId === sequence.current) setError(getErpErrorMessage(failure))
    } finally {
      if (requestId === sequence.current) setLoading(false)
    }
  }, [page, query, statusFilter, transportStatus])
  useEffect(() => { load(); return invalidate }, [load, invalidate])
  useEffect(() => {
    if (search === query) return
    const timer = setTimeout(() => { setPage(1); setQuery(search) }, 300)
    return () => clearTimeout(timer)
  }, [search, query])
  const changeFilter = (value: string) => { setPage(1); setStatusFilter(value); if (value !== 'invalid_number') setTransportStatus('') }
  const changeTransportStatus = (value: string) => { setPage(1); setTransportStatus(value) }
  const submitSearch = () => {
    if (page === 1 && search === query) load()
    else { setPage(1); setQuery(search) }
  }
  return { drivers, pagination: { ...pagination, page }, search, setSearch, statusFilter, changeFilter,
    transportStatus, changeTransportStatus, setPage, loading, error, reload: load, submitSearch }
}
